"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSIGN_USERS_ACTIVE = void 0;
var client_1 = require("@apollo/client");
exports.ASSIGN_USERS_ACTIVE = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation AssignUsersActive($input: AssignUsersActiveInput!) {\n    assignUsersActive(input: $input) {\n      users {\n        id\n        isActive\n      }\n    }\n  }\n"], ["\n  mutation AssignUsersActive($input: AssignUsersActiveInput!) {\n    assignUsersActive(input: $input) {\n      users {\n        id\n        isActive\n      }\n    }\n  }\n"])));
var templateObject_1;
